import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem, Card } from '@fluentui/react-components';
import { skeleton2, skeleton4, signinFormPosition, cardRadius, dashboardTheme } from '../../styles/customStyles';

export const SkeletonSignin = () => {
  return (
    <>
      {/* <Card> */}
      <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15 }} style={signinFormPosition}>
          <Card style={cardRadius}>
            <SkeletonItem size={48} style={skeleton4} />
            <SkeletonItem size={24} style={skeleton2} />
            <SkeletonItem size={24} style={skeleton4} />
            <SkeletonItem size={28} style={skeleton2} />
            <SkeletonItem size={24} style={skeleton4} />
            <SkeletonItem size={28} style={skeleton2} />
            <SkeletonItem size={24} style={skeleton4} />
            <SkeletonItem size={28} style={skeleton4} />
          </Card>
        </Stack>
      </FluentProvider>
      {/* </Card> */}
    </>
  );
};